export { default } from './tag-autosuggest-2';
